var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45 1C8.8213 1 9.1774 1.1475 9.43995 1.41005C9.7025 1.6726 9.85 2.0287 9.85 2.4C9.85 2.7713 9.7025 3.1274 9.43995 3.38995C9.1774 3.6525 8.8213 3.8 8.45 3.8C8.0787 3.8 7.7226 3.6525 7.46005 3.38995C7.1975 3.1274 7.05 2.7713 7.05 2.4C7.05 2.0287 7.1975 1.6726 7.46005 1.41005C7.7226 1.1475 8.0787 1 8.45 1ZM7.4 4.5H9.5C9.8713 4.5 10.2274 4.6475 10.4899 4.91005C10.7525 5.1726 10.9 5.5287 10.9 5.9V9.75H9.85V15H7.05V9.75H6V5.9C6 5.5287 6.1475 5.1726 6.41005 4.91005C6.6726 4.6475 7.0287 4.5 7.4 4.5Z",
    fill: "#616876"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdult);
export default __webpack_public_path__ + "static/media/Adult.bdc315e91c19bd9d680a510c7cb19f1b.svg";
export { ForwardRef as ReactComponent };